var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.174 3.748a4.306 4.306 0 00-1.097-1.921A4.232 4.232 0 0030.18.717C27.537 0 16.94 0 16.94 0S6.346 0 3.704.716a4.232 4.232 0 00-1.899 1.11A4.306 4.306 0 00.708 3.749C0 6.42 0 12 0 12s0 5.579.708 8.252a4.306 4.306 0 001.097 1.921c.526.532 1.18.915 1.899 1.11C6.346 24 16.94 24 16.94 24s10.596 0 13.238-.716a4.232 4.232 0 001.898-1.11 4.306 4.306 0 001.097-1.922c.708-2.673.708-8.252.708-8.252s0-5.579-.708-8.252z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.55 17.142L22.352 12 13.55 6.857v10.285z",
    fill: "#fff"
  })));
}
export default SvgYoutubeBlack;